<template>
  <div class="footer-copyright">
    <UiText
      font="body-caption"
      color="neutral-500"
    >
      <div v-html="`© ${getActualYear} ${$t('footer.copyrightTitle')} ${currentKievTime} <br> ${$t('footer.rulesFooter')}`" />
    </UiText>
  </div>
</template>

<script>
export default {
  name: 'FooterCopyright',
  data() {
    return {
      currentKievTime: '',
    }
  },
  computed: {
    getActualYear() {
      return `2024-${new Date().getFullYear()}`
    },
  },
  mounted() {
    if (!this.currentKievTime) {
      this.initTime()
    }
  },
  methods: {
    initTime() {
      const runClock = () => {
        this.currentKievTime = new Date()
          .toLocaleTimeString('ru-RU', { timeZone: 'Europe/Kiev' })
        setTimeout(runClock, 500)
      }
      runClock()
    },
  },
}
</script>

<style lang="scss" scoped>
.footer-copyright {
  padding-left: var(--padding-xl);
  padding-right: var(--padding-xl);

  @include media(desktop) {
    padding-left: var(--padding-3xl);
  }
}
</style>
